'use client'

import { useState } from 'react'
import { post } from '@/services/api/axiosClient'
import { useActionCooldown } from '@/components/organisms/hooks/useActionCooldown'

interface ResetPasswordProps {
    email: string
}
export const UseResetPasswordHook = () => {
    const { beginCooldown, isCooldownActive } = useActionCooldown()
    const [isSuccessful, setIsSuccessful] = useState<boolean>(false)
    const [resetPasswordError, setResetPasswordError] = useState<boolean>(false)
    const [isLoading, setIsLoading] = useState<boolean>(false)

    const resetPasswordFormHandler = async ({ email }: ResetPasswordProps) => {
        if (!email) {
            return
        }
        beginCooldown()
        setIsLoading(true)

        return post(`api/account/request-reset-password`, { email })
            .then(({ data: responseData }) => {
                if (responseData.isSuccess) {
                    setIsSuccessful(true)
                    setResetPasswordError(false)
                } else {
                    setResetPasswordError(true)
                }
            })
            .catch((error) => {
                setResetPasswordError(error)
            })
            .finally(() => {
                setIsLoading(false)
            })
    }

    return {
        isLoading,
        isSuccessful,
        resetPasswordFormHandler,
        hasError: resetPasswordError,
        isButtonDisabled: isLoading || isCooldownActive,
    }
}
